import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PrimaryButton from "../common/buttons/PrimaryButton";
import InputField from "../common/inputs/InputField";
import Alert from "../common/alert/Alert";
import LoadingIndicator from "../common/loadingIndicator/LoadingIndicator";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [setError] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    setIsLoading(true);
    setShowAlert(false);
    e.preventDefault();
    try {
      await login(username, password);
      navigate("/");
    } catch (error) {
      setIsLoading(false);
      setShowAlert(true);
      console.log("login failed " + error);
    }
  };

  return (
    <div className="relative flex w-screen h-screen justify-center items-center bg-white flex-col  p-2">
      <form
        onSubmit={handleSubmit}
        className=" flex flex-col gap-2 p-6 rounded-md shadow-md x sm:w-96"
      >
        <div className="font-bold felx text-center text-2xl border-b pb-2">
          <div>
            Airconnect
            <span className="text-blue-500 relative">
              travel
              <span className="text-sm text-black top-[-50%] absolute right-0">
                admin
              </span>
            </span>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-4">Login</h2>

        <div className="">
          <InputField
            label="Username"
            value={username}
            onChange={setUsername}
          ></InputField>
        </div>
        <div className="">
          <InputField
            label="Password"
            placeholder=""
            type="password"
            value={password}
            onChange={setPassword}
          ></InputField>
        </div>
        <Alert
          show={showAlert}
          message="Incorrect login credentials. Please try again"
          title=""
        ></Alert>
        <PrimaryButton type="submit" onClick={() => {}}>
          Login
        </PrimaryButton>
      </form>
      {isLoading && (
        <div className="absolute top-[50%]">
          <LoadingIndicator />
        </div>
      )}
    </div>
  );
};

export default Login;
